export default "__VITE_ASSET__ISKD6WBh__"